<template>
  <div class="base">
    <div class="top-head">
      <inside-header title="取消订单" color="white" />
      <div class="order-info-area" style="padding: 0 15px;">
        <div class="order-info">
          <a-alert message="您好，您正在申请取消订单。下单后半小时内未支付系统将自动取消，已支付订单在八小时内，用户如有任何问题可直接取消订单并退款，超过八小时，需要教员确认。如需平台介入请填写申请单"
            banner />
          <div class="lecture-details">
            <div class="title">
              {{ order_info.teaching_subject }}-{{ service_pack.title }}
            </div>
            <a-row class="package-info">
              <a-col :span="18" class="list">
                <div class="item">
                  <span class="label-title">授课时间</span>
                  <span class="content">{{ order_info.data_info_str }}</span>
                </div>
                <div class="item">
                  <span class="label-title">授课周期</span>
                  <span class="content">{{ order_info.cycle }}周</span>
                </div>
                <div class="item">
                  <span class="label-title">下次授课</span>
                  <span class="content">{{ last_teaching_time }}</span>
                  <span v-if="last_teaching_str" class="week">（{{ last_teaching_str }}）</span>
                  <span v-else class="week">无</span>
                </div>
              </a-col>
              <a-col :span="6" class="amount">
                <div class="totol">
                  <span class="prefix">￥</span>
                  <span class="money">{{ order_info.subtotal }}</span>
                </div>
                <div class="price">
                  <span class="prefix">￥</span>
                  <span class="money">{{ service_pack.price }}/小时</span>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
    <div v-if="cancellable" style="padding: 15px;" class="apply-form">
      <van-form @submit="onCancelSubmit">
        <van-field readonly clickable name="service_status" label="服务状态" :value="serverStatusText" placeholder="选择服务状态"
          :rules="[{ required: true, message: '请选择服务状态' }]" @click="state.showServerStatus = true" />
        <van-popup v-model="state.showServerStatus" position="bottom">
          <van-picker show-toolbar :columns="columns" @confirm="onServerStatusConfirm"
            @cancel="state.showServerStatus = false" />
        </van-popup>
        <!-- 取消原因 -->
        <van-field :default-index="2" readonly clickable :value="cancelReasonText" name="reason" label="取消原因"
          :rules="[{ required: true, message: '请选择取消原因' }]" placeholder="取消原因" @click="state.showCancelReason = true" />
        <van-popup v-model="state.showCancelReason" position="bottom">
          <van-picker show-toolbar :columns="columnsCancle" @confirm="onCancelReasonConfirm"
            @cancel="state.showCancelReason = false" />
        </van-popup>
        <!-- 取消原因 -->
        <van-field v-model="reason_description" name="reason_description" rows="2" autosize label="原因说明" type="textarea"
          maxlength="100" :rules="[{ required: true, message: '请输入退款原因' }]" placeholder="请输入退款原因" show-word-limit />
        <!-- 允许输入数字，调起带符号的纯数字键盘 -->
        <van-field v-if="order_info.pay_status === 'Paid' && serverStatus === 'starting'" v-model="refund_amount"
          name="refund_amount" type="number" label="退款金额" validate-trigger="onChange" :rules="[
          { required: true, message: '请输入退款金额' },
          {
            validator: handleCheckRefundFee, message: '请输入正确的金额'
          },]" />
        <div style="margin: 16px;">
          <van-button round block color="#ff5c00" type="warning" native-type="submit" :loading="state.orderCancel">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
    <div v-else-if="order_info.status === 'Cancelling'" class="cancelling-area">
      <span>您已提交了取消请求，点此</span>
      <router-link :to="{ name: 'TeacherOrderCanceling', params: { ordernum: order_info.ordernum } }">
        查看详情
      </router-link>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

export default {
  name: 'Moment',
  components: {
    InsideHeader
  },
  props: {
    ordernum: {}
  },
  data() {
    return {
      state: {
        showServerStatus: false,
        showCancelReason: false,
        orderCancel: false
      },
      showStatus: false,
      columns: [
        {
          text: '未开始服务',
          value: 'not_started'
        },
        {
          text: '已开始服务',
          value: 'starting'
        }
      ],
      columnsCancle: [
        '交通不方便',
        '时间有冲突',
        '其他'
      ],
      service_status: 'not_started',
      serverStatus: '',
      serverStatusText: '',
      cancelReason: '',
      cancelReasonText: '',
      reason: '',
      reason_description: '',
      refund_amount: null,
      statusColor: '#ff5c00',
      formValue: {
        type: '未开始服务'
      },
      amount: 0,
      order_info: {},
      last_teaching_str: '',
      last_teaching_time: '',
      service_pack: {},
      orderStatus: '',
      orderItem: [],
      payStatus: '',
      cancellable: ''
    }
  },
  watch: {
    state(val) {
      console.log(val)
    },
    showStatus(val) {
      console.log(val)
    },
    order_info(val) {
      this.orderStatus = val.status
      this.orderItem = val.order_item
      this.amount = parseFloat(val.amount)
      this.payStatus = val.pay_status

      if (val.status !== 'Complete' && val.status !== 'Cancelled' && val.status !== 'Cancelling') {
        this.cancellable = true
      }
    }
  },
  created() {
    this.loadData(this.ordernum)
  },
  methods: {
    loadData(ordernum) {
      this.loading = true
      this.$http({
        url: '/index/teacher/orderInfo',
        method: 'get',
        params: {
          ordernum: ordernum
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          console.log(res)
          const data = res.data
          this.order_info = data.order_info
          this.last_teaching_str = data.last_teaching_str
          this.last_teaching_time = data.last_teaching_time
          this.service_pack = data.service_pack
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    goTutor() {
      console.log(1)
    },
    onServerStatusConfirm(value) {
      this.serverStatusText = value.text
      this.serverStatus = value.value
      this.state.showServerStatus = false
    },
    onCancelReasonConfirm(value) {
      this.cancelReasonText = value
      this.cancelReason = value
      this.state.showCancelReason = false
    },
    onCancelSubmit(values) {
      console.log('submit', values)
      values.service_status = this.serverStatus
      values.ordernum = this.ordernum
      this.state.orderCancel = true
      this.$http({
        url: '/index/teacher/cancelOrder',
        method: 'post',
        data: values
      }).then(res => {
        this.state.orderCancel = false
        if (res.status === 'success') {
          this.$toast.success('取消订单成功')
          // 进入取消中页面
          this.$router.push({ name: 'TeacherOrderCanceling', params: { ordernum: this.ordernum } })
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    handleCheckRefundFee(value) {
      console.log(value)
      var re = /^[0-9]+.?[0-9]*$/
      if (!re.test(value)) {
        return false
      } else if (value > this.amount) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="stylus">
  .base {
      min-width: 280px;
      max-width: 420px;
      margin: auto;
      background-color: #fff;
  }

  .order-info-area {
    margin-top: 20px;
    overflow hidden
  }

  .top-head {
    width: 100%;
    background: url('~@/assets/order/back@2x.png') no-repeat;
    // 背景图片自适应div
    background-size: contain

    .order-info {
      background-color: #ffffff;
      border-radius: 10px;
      padding: 15px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

      .lecture-details {
        padding: 10px 0;
        margin-top: 20px;

        .title {
          font-family: PingFang-SC-Bold;
          font-size: 15px;
          line-height: 16px;
          color: #333333;
          font-weight: bold;
        }

        .package-info {
          margin-top: 10px;

          .list {
            .item {
              line-height: 21px;

              .label-title {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 21px;
                color: #999;
              }

              .content {
                margin-left: 5px;
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                color: #666666;
              }

              .week {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                color: #ff5c00;
              }
            }
          }

          .amount {
            text-align: right;

            .totol {

              .prefix {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 19px;
                color: #333333;
              }

              .money {
                font-family: PingFang-SC-Medium;
                font-size: 18px;
                color: #333333;
              }

            }

            .price {

              .prefix {
                font-family: PingFang-SC-Medium;
                font-size: 10px;
                line-height: 19px;
                color: #999;
              }

              .money {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 19px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }

  // 时间安排
  .schedule {
    padding: 30px 15px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
    margin-top: 15px;

    .teacher-area {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      .head-img {
        img {
          width: 30px;
          height: 30px;
        }
      }

      .identity {
        .name {
          font-family: PingFang-SC-Bold;
          font-size: 15px;
          line-height: 18px;
          color: #333333;
          font-weight: bold;
        }

        .desc {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #999999;
        }
      }

      .duration {
        text-align: right;

        span {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #333333;
        }
      }
    }
    // dd
    .lable-desc {
      font-family: PingFang-SC-Medium;
      font-size: 15px;
      line-height: 32px;
      color: #333333;
    }

    .date-arr {

      .item {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 16px;
        color: #333333;
        margin-right: 15px;
      }

      .complete {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 16px;
        color: #999999;
      }
    }
  }

  .order-area {
    margin-top: 20px;

    font-family: PingFang-SC-Medium;
    font-size: 14px;
    line-height: 24px;
    color: #999999;
  }

  .pay-area {
    height: 56px;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 10px 15px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

    .left {
      float: left;

      .label-text {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 32px;
        color: #999999;
      }

      .prefix {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        line-height: 19px;
        color: #ff5c00;
      }

      .total {
        font-family: PingFang-SC-Medium;
        font-size: 21px;
        color: #ff5c00;
      }
    }

    .right {
      float: right

      .cancel-btn {
        width: 87px;
        height: 31px;
        border-radius: 15px;
        border: solid 1px #ececec;

        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 14px;
        color: #999999;

        margin-right: 10px;
      }

      .pay-btn {
        width: 75px;
        height: 31px;
        background-color: #ff5c00;
        border-radius: 15px;
      }
    }
  }

  .cancelling-area {
    padding: 15px;
    margin-top: 10px;
  }

</style>
